import { render, staticRenderFns } from "./AppPermissionDetailScreen.vue?vue&type=template&id=0f404c04"
import script from "./AppPermissionDetailScreen.vue?vue&type=script&lang=js"
export * from "./AppPermissionDetailScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports